export const fetchAndSetAuthorizedImage = async (src, token, image) => {
    try {
        const response = await fetch(src, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`Service authorization error: ${response.status} ${response.statusText}`);
        }
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        image.getImage().src = url;
    }
    catch (error) {
        console.error(error instanceof Error ? error.message : error);
    }
};
//# sourceMappingURL=utils.js.map